import { render, staticRenderFns } from "./PageColumn.vue?vue&type=template&id=421511ba&scoped=true&"
import script from "./PageColumn.vue?vue&type=script&lang=js&"
export * from "./PageColumn.vue?vue&type=script&lang=js&"
import style0 from "./PageColumn.vue?vue&type=style&index=0&id=421511ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421511ba",
  null
  
)

export default component.exports